import { getOrDelete } from './glosbe-dictionary-api-helper';
let similarPhrasesUrl = 'https://iapi.glosbe.com/iapi3/similar/similarPhrasesMany';
;
export function getSimilarPhrases({ l1, l2, phrase, number }) {
    const data = [
        {
            "reverse": false,
            "searchMethod": "WORDLIST",
            "sortMethod": "ALPHABETICALLY",
            "includeSelf": true,
            "number": number,
        },
        {
            "reverse": false,
            "searchMethod": "PREFIX",
            "sortMethod": "PRIORITY",
            "includeSelf": true,
            "number": number
        },
        {
            "reverse": false,
            "searchMethod": "TRANSLITERATED",
            "sortMethod": "PRIORITY",
            "includeSelf": true,
            "number": number
        },
        {
            "reverse": false,
            "searchMethod": "FUZZY",
            "sortMethod": "PRIORITY",
            "includeSelf": true,
            "number": number
        },
        {
            "reverse": true,
            "searchMethod": "WORDLIST",
            "sortMethod": "ALPHABETICALLY",
            "includeSelf": true,
            "number": number
        },
        {
            "reverse": true,
            "searchMethod": "PREFIX",
            "sortMethod": "PRIORITY",
            "includeSelf": true,
            "number": number
        },
        {
            "reverse": true,
            "searchMethod": "TRANSLITERATED",
            "sortMethod": "PRIORITY",
            "includeSelf": true,
            "number": number
        },
        {
            "reverse": true,
            "searchMethod": "FUZZY",
            "sortMethod": "PRIORITY",
            "includeSelf": true,
            "number": number
        }
    ];
    const requestOptions = {};
    const searchCriteria = data.map(item => `${item.searchMethod}-${item.sortMethod}-${item.number}-${item.reverse ? 'r' : 's'}`).join(";");
    const params = {
        p: phrase,
        l1,
        l2,
        'removeDuplicates': "true",
        searchCriteria
    };
    return getOrDelete({ endpoint: "similar/similarPhrasesMany", params, options: requestOptions });
}
